'use client'

import { Accordion } from 'fukku/Accordion'
import type React from 'react'
import { cx } from 'utils/cx'

import { dataTestIds } from '../../../constants/dataTestIds/dataTestIds'
import { useAnalytics } from '../../../contexts/AnalyticsProvider/AnalyticsProvider'
import { PdpActionEvents } from '../../../types/PdpActionEvents'

import styles from './PropertiesWrapper.module.scss'

type PropertiesWrapperProps = {
	className?: string
	children: [React.ReactElement, React.ReactElement]
	title: string
}

export function PropertiesWrapper({
	className,
	children,
	title,
}: PropertiesWrapperProps): React.ReactNode {
	const { sendPdpActionEvent } = useAnalytics()

	return (
		<div className={cx(className)}>
			<div
				className={styles.propertiesWrapper}
				data-testid={
					dataTestIds['pdp.productDetails.compositionOriginAndCare.accordion']
				}
			>
				<Accordion
					id='pdp.washingRules'
					data={[
						{
							title,
							onExpanded: () =>
								sendPdpActionEvent(PdpActionEvents.PRODUCT_CARE),
							shouldScroll: false,
							content: children[0],
						},
					]}
				/>
			</div>
			{children[1]}
		</div>
	)
}
